import { useTheme } from "@mui/material";
import { useTeamConfig } from "../components/TeamConfigProvider";

// type defs
export type TSSTextVariant =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "body"
  | "subtitle1"
  | "body1"
  | "body2"
  | "caption";

export const ssTheme = {
  text: {
    headingSizeIncRatio: 1.25, // golden ratio ɸ = 1.25
    baseFontSize: 16,
    captionFontSize: 12,
    lineHeight: 1.45,
  },
  colors: {
    teamPrimary: null as unknown as string,
    teamSecondary: null as unknown as string,
    border: "#D4D4D8",
    common: {
      black: "#000000",
      white: "#FFFFFF",
    },
    background: {
      white: "#FFFFFF",
      gray: "#FAFAFA",
    },
    gray: {
      50: "#F9F9F9",
      100: "#DEDEDE",
      200: "#A1A1AA",
      300: "#5A5A5A",
      400: "#18181B",
      500: "#444444",
    },
  },

  // methods
  calcFontSize(variant?: TSSTextVariant): number {
    // heading level fonts
    if (variant?.match(/h[1-6]/)) {
      const exponent = 6 - Number(variant.slice(1));
      return (
        this.text.baseFontSize *
        Math.pow(this.text.headingSizeIncRatio, exponent)
      );
    }
    // body/description level text
    if (variant == "body") return this.text.baseFontSize;
    // caption level text
    if (variant == "caption") return this.text.captionFontSize;
    return this.text.baseFontSize; // satisfying TS
  },

  pxToRem(px: number) {
    return `${px / this.text.baseFontSize}rem`;
  },
};

export function useSSTheme() {
  const muiTheme = useTheme();
  const { TEAM_GLOBAL_SETTINGS } = useTeamConfig();

  if (!ssTheme.colors.teamPrimary || !ssTheme.colors.teamSecondary) {
    ssTheme.colors.teamPrimary = TEAM_GLOBAL_SETTINGS?.COLORS_PRIMARY as string;
    ssTheme.colors.teamSecondary =
      TEAM_GLOBAL_SETTINGS?.COLORS_SECONDARY as string;
  }

  return { ...ssTheme, mui: muiTheme };
}
